module.exports = "/images/oculus-11.jpg";